import classNames from "classnames";
import useTranslation from "@hooks/use_translation";
import "./worksite_pills.scss";

const WORKSITE_CATEGORIES = ["on_site", "hybrid", "remote"] as const;
const LABEL_KEYS: Record<(typeof WORKSITE_CATEGORIES)[number], string> = {
  on_site: "onSite",
  hybrid: "hybrid",
  remote: "remote",
};

type Props = {
  selectedCategories: string[];
  onChange: (next: string[]) => void;
};

const WorksitePills = ({ selectedCategories, onChange }: Props) => {
  const { t } = useTranslation("onboarding", { keyPrefix: "submit" });

  const toggle = (category: string) => {
    onChange(
      selectedCategories.includes(category)
        ? selectedCategories.filter((selected) => selected !== category)
        : [...selectedCategories, category],
    );
  };

  return (
    <div className="worksite-pills">
      {WORKSITE_CATEGORIES.map((category) => {
        const selected = selectedCategories.includes(category);

        return (
          <button
            key={category}
            type="button"
            aria-pressed={selected}
            onClick={() => toggle(category)}
            className={classNames("worksite-pills__pill", {
              "worksite-pills__pill--selected": selected,
            })}
          >
            {t(`worksiteOptions.${LABEL_KEYS[category]}`)}
          </button>
        );
      })}
    </div>
  );
};

export default WorksitePills;
